import { RootState } from '../../../applicationStore';
import { CustomerState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getCustomerState = (state: RootState): CustomerState =>
  state.customer;

export const getCustomerLoader = createSelector(
  getCustomerState,
  (state): boolean => state.loading,
);

export const getCustomerData = createSelector(
  getCustomerState,
  (state): CustomerState['data'] | null => state?.data || null,
);